import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * `/app/*` segments that must stay reachable without organization employee
 * or completed business registration (profile, support, etc.).
 */
export const ACCOUNT_ONLY_APP_PATHS = new Set([
  'profile',
  'support',
  'about',
  'notifications',
]);

export function routeMatchesAccountOnlyPath(
  route: ActivatedRouteSnapshot | null
): boolean {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const p = current.routeConfig?.path;
    if (p && ACCOUNT_ONLY_APP_PATHS.has(p)) {
      return true;
    }
    current = current.firstChild;
  }
  return false;
}
